/**
 * @fileoverview
 * Registry for clearing in-progress audit / asset-entry session state when the
 * user confirms a Branch or Audit Type switch from the header.
 * Feature state services register their clearState/clearContext callbacks;
 * @core and @shared must not import feature modules directly.
 *
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { Injectable } from '@angular/core';

export type AuditSessionCleanupFn = () => void;

@Injectable({ providedIn: 'root' })
export class AuditSessionExitService {
  private readonly cleanups = new Set<AuditSessionCleanupFn>();

  /**
   * Register a cleanup callback. Returns an unregister function.
   */
  registerCleanup(fn: AuditSessionCleanupFn): () => void {
    this.cleanups.add(fn);
    return () => this.cleanups.delete(fn);
  }

  /**
   * Invoke all registered cleanups. Errors in one cleanup do not block others.
   */
  clearAll(): void {
    for (const fn of this.cleanups) {
      try {
        fn();
      } catch {
        // Ignore individual cleanup failures so exit always completes.
      }
    }
  }
}
